import request from '../utils/https'

// 會員註冊
export function userRegister (params) {
    return request({
        url: '/user/register',
        method: 'post',
        data:params
    })
}

// 會員登入
export function userLogin (params) {
    return request({
        url: '/user/login',
        method: 'post',
        data:params
    })
}

// 會員登出
export function getUserInfo (params) {
    return request({
        url: '/user/info',
        method: 'post',
        data:params
    })
}

// 會員登出
export function userLogout (params) {
    return request({
        url: '/user/logout',
        method: 'post',
        data:params
    })
}

// 查看我的物品
export function getMyExchangeItem (params) {
    return request({
        url: '/user/myItemList',
        method: 'post',
        data:params
    })
}